module.exports = __webpack_public_path__ + "static/media/unsorted_sort.caa33880.svg";